export default __webpack_public_path__ + "static/conseil-prompt-c862a4aa05532b7b8115cc36f0f7e46f.webp";